import {
  DeleteCertificateInput,
  RequestCertificateInput,
  VanityDomainType,
} from "shared";
import { axiosClient } from "utilz";
import { apiErrorHandler } from "utilz/helpers";
const BASE_URL = import.meta.env.VITE_APP_VANITY_BASE_URL;

export const requestCertificate = async ({
  domain,
  mspId,
  vanityUrlType,
}: RequestCertificateInput) => {
  try {
    const url = `${BASE_URL}/api/domains/request`;
    const response = await axiosClient.post(url, {
      domainName: domain,
      customerId: mspId,
      vanityUrlType,
    });
    const resData = response.data;
    if (resData.success && resData.statusCode === 201) {
      return resData?.data || {};
    } else {
      throw response;
    }
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const checkCertificateStatus = async (id: string) => {
  try {
    const url = `${BASE_URL}/api/domains/${id}/status`;
    const response = await axiosClient.get(url);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData?.data || {};
    } else {
      throw response;
    }
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const getInstructions = async (id: string) => {
  try {
    const url = `${BASE_URL}/api/domains/${id}/instructions`;
    const response = await axiosClient.get(url);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData?.data || {};
    } else {
      throw response;
    }
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const getAllCertificates = async (
  mspId: string,
): Promise<VanityDomainType[] | undefined> => {
  try {
    const url = `${BASE_URL}/api/domains/customer/${mspId}`;
    const response = await axiosClient.get(url);
    const resData = response.data;
    if (resData.success) {
      return resData?.data?.domains || [];
    } else {
      throw response;
    }
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const deleteCertificate = async ({
  id,
  mspId,
}: DeleteCertificateInput) => {
  try {
    const url = `${BASE_URL}/api/domains/${id}`;
    const response = await axiosClient.delete(url, {
      data: {
        customerId: mspId,
      },
    });
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData?.data || {};
    } else {
      throw response;
    }
  } catch (error: any) {
    apiErrorHandler(error);
  }
};
